export default __webpack_public_path__ + "media/components/ui/Slider/carousel-next-2fdd77383c3c7d2de063ba807354fd65.png";